
import { Component, Vue } from 'vue-property-decorator'
import dealModule from '@/store/deal'
import { DealStatistics } from '../../../types/Deal'
import DealStatisticsCard from '@/components/company/deal/DealStatisticsCard.vue'

@Component({
  name: 'DealStatisticsDialog',
  components: {
    DealStatisticsCard
  }
})
class DealStatisticsDialog extends Vue {
  private visible = true
  private loading = false

  private get statistics(): DealStatistics | undefined {
    return dealModule.statistics
  }

  private async created() {
    await dealModule.fetchStatistics(dealModule.deal!._id)
  }
}

export default DealStatisticsDialog
